<template>
  <div class="department-multi-check">
    <kt-autoselect
      :label="props.label"
      :options="departmentOptions"
      display-by="label"
      value-by="value"
      :multiple="true"
      v-model="model"
      search-placeholder="Search department..."
      @change="handleChange"
    />
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue';
import KtAutoselect from '@/components/UI/KtAutoselect.vue';
import OptionsService from '@/services/OptionsService';

interface DepartmentOption {
  label: string;
  value: string;
}

const props = defineProps({
  label: { 
    type: String, 
    default: 'Select Department' 
  }
});

const emit = defineEmits<{
  change: [value: string[]];
}>();

const model = defineModel<string[]>({
  default: () => []
});

const departmentOptions = ref<DepartmentOption[]>([]);

const DEPARTMENT_OPTION_KEY = 'departments_json';

const loadDepartmentOptions = async () => {
  try {
    const optionValue = await OptionsService.get(DEPARTMENT_OPTION_KEY);
    if (optionValue) {
      const depts = JSON.parse(optionValue);
      departmentOptions.value = depts.map((d: any) => ({ value: d.name, label: d.name }));
    } else {
      departmentOptions.value = [];
    }
  } catch (error) {
    console.error('Failed to load departments:', error);
    departmentOptions.value = [];
  }
};

onMounted(() => {
  loadDepartmentOptions();
});

const handleChange = (value: string[]) => {
  emit('change', value);
};
</script>
